<template lang="pug">
  div#app
    v-dialog(v-if='isIdle && isAuth' persistent  :value='isIdle'  max-width='400px' transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%;')
        idle-dialog(v-if='isIdle && isAuth' @close="isIdle=false")
    router-view
    //- .upgrade-dialog(v-if="prompt")
      .upgrade-dialog__message
        | A new version is found. Refresh to load it?
      .upgrade-dialog__button.upgrade-dialog__button--accept(@click="upgrade")
        | Refresh
      .upgrade-dialog__button.upgrade-dialog__button--cancel(@click="showUpgradeUI = false")
        | Later
</template>

<script>
/* eslint-disable */
  import idleDialog from './components/custom/dialogs/IdleDialog'
  import profileDialog from './components/custom/dialogs/profileDialog'
  import axios from 'axios'
  import  { messaging } from '@/plugins/auth/firebase'
  import * as vars from '@/vars.json'
  export default {
    name: 'App',

    components: {
      idleDialog: idleDialog,
      profileDialog: profileDialog
    },

    data () {
      return {
        time: 10000,
        showUpgradeUI: false,
      }
    },

    computed: {
      isAuth () {
        return !!this.$store.state.users.user
      },
      isIdle () {
        return this.$store.state.idleVue.isIdle
      },
    },

    watch: {
      isAuth: function (val) {
        if (val) {
          // console.log(val)
          this.getMessagingToken();
          // this.activateActivityTracker()
          if (this.$route.params.pathMatch !== 'login' && this.$route.params.pathMatch !== 'register') {
            // entra si no es necesaria redireccion
          } else {
            // this.$router.replace('summary').catch(err => {})
          }
        } else {
          // this.$router.replace('login').catch(err => {})
        }
      },
    },

    async created () {
      const vm = this
      vm.loadCookies()
      if (this.$workbox) {
        this.$workbox.addEventListener("waiting", () => {
          this.showUpgradeUI = true;
        });
      }
    },
    mounted() {
      this.listenTokenRefresh();
      /* const drift = this.$drift
      drift.on("ready", api => {
        drift.hide()
      }) */
      // try {
      //   this.getMessagingToken();
      // }catch(err){
      //   // console.log(err)
      // }
    },
    methods: {
      getMessagingToken () {
        messaging.getToken().then(async (token) => {
          // console.log('entra en esto : ' , token)
          if (token) {
            const currentMessageToken = window.localStorage.getItem('messagingToken')
            // console.log('token will be updated', currentMessageToken !== token)
            if(currentMessageToken !== token){
              await this.saveToken(token)
            }
          } else {
            // console.log('No Instance ID token available. Request permission to generate one.');
            this.notificationsPermisionRequest();
          }
        }).catch(function(err) {
          // console.log('An error occurred while retrieving token. ', err);
        });
      },
      notificationsPermisionRequest () {
        messaging.requestPermission()
          .then(() => {
            this.getMessagingToken();
          })
          .catch((err) => {
            // console.log('Unable to get permission to notify.', err);
          });
      },
      listenTokenRefresh() {
        const currentMessageToken = window.localStorage.getItem('messagingToken')
        // console.log('currentMessageToken', currentMessageToken);
        if(!!currentMessageToken){
          messaging.onTokenRefresh(function() {
            messaging.getToken().then(function(token) {
              this.saveToken(token);
            }).catch(function(err) {
              // console.log('Unable to retrieve refreshed token ', err);
            });
          });
        }
      },
      saveToken(token) {
        const vm = this;
        const uid = vm.$store.state.users.user.uid || null
        // console.log('tokens', token)
        // console.log('SE GUARDA EL TOKEN')
        if(uid){
          axios.post(`${vars.url}/generalSubscription`,{
            token:token,
            uid: uid
          })
            .then(response => {
              window.localStorage.setItem('messagingToken',token)
              // console.log(response)
            }).catch((err) => {
            // console.log(err)
          })
        }
      },
      async upgrade() {
        this.showUpgradeUI = false
        await this.$workbox.messageSW({ type: "SKIP_WAITING" });
      },
      loadCookies () {
        this.$store.dispatch('users/loadCookies')
      },
    },

  }
</script>
<style lang="scss">
  #app{
    overflow-x: hidden;
  }
  .v-dialog--active, .v-dialog{
    box-shadow: none !important;
  }

  .slide-left-enter-active,
  .slide-left-leave-active,
  .slide-right-enter-active,
  .slide-right-leave-active {
      transition-duration: 0.5s;
      transition-property: height, opacity, transform;
      transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
      overflow: hidden;
  }

  .slide-left-enter,
  .slide-right-leave-active {
      opacity: 0;
      transform: translate(2em, 0);
  }

  .slide-left-leave-active,
  .slide-right-enter {
      opacity: 0;
      transform: translate(-2em, 0);
  }



  .upgrade-dialog {
    position: fixed;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 4px;
    box-sizing: border-box;
    padding: 8px 12px;
    color: white;
    background-color: #2c3e50;
    box-shadow: 0 4px 4px rgba(#2c3e50, 0.4);
    display: grid;
    grid-template-columns: 1fr max-content;
    gap: 8px;
    &__message {
      grid-column: 1 / 3;
    }
    &__button {
      padding: 0 8px;
      height: 36px;
      line-height: 36px;
      font-weight: bold;
      cursor: pointer;
      user-select: none;
      &--accept {
        justify-self: end;
      }
    }
  }
</style>
